import loadable from '@loadable/component';

export const UnsubscribePageLoadable = loadable(
  () => import('./UnsubscribePage'),
  { resolveComponent: (module) => module.UnsubscribePage },
);
